module.exports = __webpack_public_path__ + "static/media/open-all.96a3115f.svg";